import React from "react";
import { Toaster } from "react-hot-toast";
import Header from "./Header";
import Footer from "./Footer";
import { useAuth } from "../../hooks/useAuth";

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { user, isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <Toaster
        position="bottom-right"
        toastOptions={{
          // Configurações globais
          duration: 4000, // 4 segundos (padrão é 4000ms)

          // Estilos personalizados por tipo
          success: {
            duration: 3000, // 3 segundos para sucesso
            style: {
              background: "#10b981",
              color: "#fff",
            },
            iconTheme: {
              primary: "#fff",
              secondary: "#10b981",
            },
          },
          error: {
            duration: 5000, // 5 segundos para erro (mais tempo para ler)
            style: {
              background: "#ef4444",
              color: "#fff",
            },
            iconTheme: {
              primary: "#fff",
              secondary: "#ef4444",
            },
          },
          loading: {
            duration: Infinity, // Loading não some automaticamente
          },
        }}
      />
      <Header isLoggedIn={isAuthenticated} userName={user?.nome} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
